export interface PlanTierLike {
  sort_order?: number | null;
  uuid?: string;
}

export function planSortOrder(plan: PlanTierLike | null | undefined): number {
  if (!plan) return 0;
  const order = Number(plan.sort_order);
  return Number.isFinite(order) ? order : 0;
}

/** Lower sort_order = lower tier (e.g. Pay-As-You-Go before Professional). */
export function isPlanDowngrade(
  target: PlanTierLike,
  current: PlanTierLike | null | undefined
): boolean {
  if (!current?.uuid) return false;
  return planSortOrder(target) < planSortOrder(current);
}

export function isPlanUpgrade(
  target: PlanTierLike,
  current: PlanTierLike | null | undefined
): boolean {
  if (!current?.uuid) return false;
  return planSortOrder(target) > planSortOrder(current);
}
